






































































import Vue from 'vue'
import { postUser,patchUser } from '@/modules/user/user.service';
import { getSites } from '@/modules/site/site.service';
import { UserRoles } from '@/modules/auth/auth.model';

export default Vue.extend({
    name: 'UserForm',

    props: ['formTitle','formAction','dataUserProp'],
    data: () => ({
      userFormDialog: false,
      msgError: '',
      msgSuccess: '',
      buttonTitle: 'Créer',
      buttonIcon: 'mdi-pencil-plus-outline',
      roleList: [
          {code: UserRoles.ADMIN.key,label: UserRoles.ADMIN.desc},
          {code: UserRoles.SITEMNGR.key,label: UserRoles.SITEMNGR.desc},
          {code: UserRoles.USER.key,label: UserRoles.USER.desc}
          ],
      userData: {
        firstName:'',
        lastName:'',
        email:'',
        password:'',
        role:'USER'
      },
      sitesIds: [] as number[],
      sitesList: []
    }),
    mounted() {
        this.initProps();
        this.getSitesList();  
    },
    methods: {
      initProps() {
        if (this.dataUserProp){
          this.buttonTitle = '';
          this.buttonIcon = 'mdi-file-document-edit-outline';
          this.userData = this.dataUserProp.user;
          for (const site of this.dataUserProp.sites){
            this.sitesIds.push(site.id);
          }
        }
      },
      handleClick() {
        this.$emit('click');
      },
      close(reset: boolean) {
        if (reset)
          this.resetData();
        this.userFormDialog = false;
        this.handleClick();
      },
      resetData(){
        this.userData = {
            firstName:'',
            lastName:'',
            email:'',
            password:'',
            role:'USER'
        };
        this.sitesIds = [];
        this.msgError = '';
        this.msgSuccess = '';
      },
      save(){
        if (this.dataUserProp){
          this.updateUser();
        }else{
          this.createUser();
        }
      },
      createUser(){
        this.msgSuccess = '';
        this.msgError= '';
        postUser({user:this.userData,sites:this.sitesIds}).then(res=>{
            if (res.data){
                this.msgSuccess = 'Utilisateur créé.'
                this.close(true);
            }else if (res.error){
                this.msgError = 'Erreur dans la création de l\'utilisateur.'
            }
        });
      },
      updateUser(){
        this.msgSuccess = '';
        this.msgError= '';
        patchUser({user:this.userData,sites:this.sitesIds}).then(res=>{
            if (res.data){
                this.msgSuccess = 'Utilisateur modifié.'
                this.close(false);
            }else if (res.error){
                this.msgError = 'Erreur dans la modification de l\'utilisateur.'
            }
        });
      },
      getSitesList(){
          getSites().then(res=>{
            if (res.data){
            this.sitesList = res.data;
            }else if (res.error){
            this.msgError = 'Erreur dans la recupération des données des sites.'
            }
        });
      }
    }
  })
